<ion-header>
  <ion-toolbar>
    <ion-title class="tb">
      2 Gruppen & KO-System
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-item class="combo-btn">
      <ion-label class="plus-btn" (click)="onAddEvent()">
        +
      </ion-label>
      <ion-select class="pick" [(ngModel)]="plan.eventId" [placeholder]="events[0]?.name">
        <ion-select-option *ngFor="let event of events" [value]="event.id">
          {{ event.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-label>
        Name
      </ion-label>
      <ion-input [(ngModel)]="plan.name">
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-label>
        Sportart:
      </ion-label>
      <ion-select [(ngModel)]="plan.sportArt" multiple="false">
        <ion-select-option>Fußball</ion-select-option>
        <ion-select-option>Dart</ion-select-option>
        <ion-select-option>Esport</ion-select-option>
        <ion-select-option>Tennis</ion-select-option>
        <ion-select-option>Volleyball</ion-select-option>
        <ion-select-option>Bierpong</ion-select-option>
        <ion-select-option>Handball</ion-select-option>
        <ion-select-option>Tischtennis</ion-select-option>
        <ion-select-option>Badminton</ion-select-option>
        <ion-select-option>Basketball</ion-select-option>
        <ion-select-option>Kicker</ion-select-option>
        <ion-select-option>Padel</ion-select-option>
        <ion-select-option>Snooker</ion-select-option>
        <ion-select-option>Petanque</ion-select-option>
        <ion-select-option>Golf/Minigolf</ion-select-option>
        <ion-select-option>Andere Sportart</ion-select-option>
        <ion-select-option>Keine Sportart</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item class="no-btm-border">
      <ion-label>
        Mannschaften
      </ion-label>
      <ion-input [disabled]="true" value="{{ plan.teamNum }}">
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-range min="2" max="256" [(ngModel)]="plan.teamNum" color="primary">
        <ion-label slot="start">2</ion-label>
        <ion-label slot="end">256</ion-label>
      </ion-range>
    </ion-item>

    <!-- Turnierbaum -->

    <ion-item class="no-btm-border">
      <ion-label>
        Gruppen
      </ion-label>
      <ion-input [disabled]="true" value="{{ plan.groupNum }}">
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-range min="2" max="30" [(ngModel)]="plan.groupNum" color="primary" (ionChange)="onTeamNumChange($event)">
        <ion-label slot="start">2</ion-label>
        <ion-label slot="end">30</ion-label>
      </ion-range>
    </ion-item>

    <ion-item class="no-btm-border">
      <ion-label>
        Gruppengröße
      </ion-label>
      <ion-input [disabled]="true" value="{{ plan.groupSize }}">
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-range min="2" max="30" [(ngModel)]="plan.groupSize" color="primary" (ionChange)="onTeamNumChange($event)">
        <ion-label slot="start">2</ion-label>
        <ion-label slot="end">30</ion-label>
      </ion-range>
    </ion-item>

    <ion-item>
      <ion-label>
        Spielrunden
      </ion-label>
      <ion-select [(ngModel)]="plan.round" multiple="false">
        <ion-select-option>Hinrunde</ion-select-option>
        <ion-select-option>Hin- & Rückrunde</ion-select-option>
        <ion-select-option>3 Runden</ion-select-option>
        <ion-select-option>4 Runden</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item>
      <ion-label>
        Platzierungen
      </ion-label>
      <ion-select [(ngModel)]="plan.round" multiple="false">
        <ion-select-option>Platz 1 + 2</ion-select-option>
        <ion-select-option>Platz 1 bis 3</ion-select-option>
        <ion-select-option>Platz 1 bis 4</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>

  <ion-button expan="block" (click)="save()">Erstellen</ion-button>
</ion-content>